import styled from "styled-components";
import AddNewButton from "./AddNewButton";

export default styled(AddNewButton)`
  .main-nav-link {
    background-color: transparent;
    border: none;
    color: #fff;
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 1.8rem;
    color: #dee2e6;
  }
`;
